(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["decorative-icon"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    if (window.__decorativeIconInit) return;
    window.__decorativeIconInit = true;

    var PROCESSED_ATTR = 'data-decorative-placed';

    function placeIcon(iconEl, sectionRoot) {
      if (iconEl.hasAttribute(PROCESSED_ATTR)) return;

      var selector = iconEl.getAttribute('data-target-selector');
      var target = null;

      if (selector) {
        try {
          target = sectionRoot.querySelector(selector);
        } catch (e) {
          target = null;
        }
      }

      if (!target) {
        target = sectionRoot;
      }

      var computedPosition = window.getComputedStyle(target).position;
      if (computedPosition === 'static') {
        target.classList.add('decorative-icon__target-relative');
      }

      if (iconEl.parentElement !== target) {
        target.appendChild(iconEl);
      }

      iconEl.setAttribute(PROCESSED_ATTR, 'true');
    }

    function initSection(sectionRoot) {
      if (!sectionRoot) return;
      var icons = sectionRoot.querySelectorAll('[data-decorative-icon]');
      icons.forEach(function (iconEl) {
        placeIcon(iconEl, sectionRoot);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-decorative-icon]').forEach(function (iconEl) {
        var sectionId = iconEl.getAttribute('data-section-id');
        var sectionRoot = document.getElementById('shopify-section-' + sectionId);
        if (sectionRoot) {
          placeIcon(iconEl, sectionRoot);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initSection(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var sectionRoot = event.target.closest('[id^="shopify-section-"]');
      if (sectionRoot) initSection(sectionRoot);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
